"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--card)",
          "--normal-text": "var(--foreground)",
          "--normal-border": "var(--border)",
          "--success-bg": "var(--color-olive-bg)",
          "--success-text": "var(--color-olive)",
          "--success-border": "var(--color-olive)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };